import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const rochePaginationButtonCss = "roche-pagination-button{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;font-weight:400;height:2.5rem;width:2.5rem;text-align:center;line-height:2.5rem !important;color:#544f4f;letter-spacing:-1px;user-select:none;display:flex;justify-content:center;align-items:center;cursor:pointer}@media (min-width: 64rem){roche-pagination-button{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}roche-pagination-button[active]{background-color:var(--color-interactive--primary-hover);fill:#fff;color:#fff;cursor:default}roche-pagination-button[disabled]{background-color:transparent;cursor:default;fill:#c2bab5;color:#c2bab5;pointer-events:none}roche-pagination-button:hover:not([disabled],[active]){background-color:#706b69;fill:#fff;color:#fff}";
const RochePaginationButtonStyle0 = rochePaginationButtonCss;

const RochePaginationButton$1 = /*@__PURE__*/ proxyCustomElement(class RochePaginationButton extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.active = undefined;
    }
    render() {
        return (h("slot", { key: 'b9b63b9807ad8781df6ff61915c24b5b969d8513' }));
    }
    static get style() { return RochePaginationButtonStyle0; }
}, [4, "roche-pagination-button", {
        "active": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-pagination-button"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-pagination-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RochePaginationButton$1);
            }
            break;
    } });
}

const RochePaginationButton = RochePaginationButton$1;
const defineCustomElement = defineCustomElement$1;

export { RochePaginationButton, defineCustomElement };

//# sourceMappingURL=roche-pagination-button.js.map